import React from 'react';
import styled from 'styled-components';
import Box from '../../Box';
import ModalClose from './ModalClose';
import { getFlexProp } from './utils';

const ModalHeaderContainer = styled(Box).attrs(p => ({
  justify: getFlexProp(p.align),
  mb: '13px',
  ...(p.padding && { padding: p.padding }),
  ...(p.borderBottom && { borderBottom: p.borderBottom }),
  ...(p.borderColor && { borderColor: p.borderColor }),
  ...(p.pb && { pb: p.pb }),
}))`
  text-align: ${p => (p.align ? p.align : 'inherit')};
`;

const ModalHeader = ({
  children,
  align,
  onClose,
  className,
  padding,
  borderBottom,
  borderColor,
  pb,
}) => (
  <ModalHeaderContainer
    align={align}
    className={className}
    padding={padding}
    borderBottom={borderBottom}
    borderColor={borderColor}
    pb={pb}
  >
    <ModalClose onClose={onClose} />
    {children}
  </ModalHeaderContainer>
);

export default ModalHeader;
